import {
  createMemoryHistory,
  createWebHistory,
  type RouteLocationNormalized,
  type RouteRecordRaw,
  type RouterHistory,
} from 'vue-router';
import { isOfficeAddinHost } from '@/office/utils';
import LoginOffice from '@/office/views/LoginOffice.vue';
import PlaybooksOffice from '@/office/views/PlaybooksOffice.vue';
import TemplatesOffice from '@/office/views/TemplatesOffice.vue';

export const officeRoutes: RouteRecordRaw[] = [
  {
    path: '/office-home',
    name: 'office-home',
    redirect: { name: 'file-vault' },
    meta: { requiresAuth: true, requiresAdmin: false },
  },
  {
    path: '/office-login',
    name: 'office-login',
    component: LoginOffice,
    meta: {
      requiresAuth: false,
      requiresAdmin: false,
      layout: 'auth',
    },
  },
  {
    path: '/office-templates',
    name: 'office-templates',
    component: TemplatesOffice,
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
    },
  },
  {
    path: '/office-playbooks',
    name: 'office-playbooks',
    component: PlaybooksOffice,
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
      requiredPermissions: ['can_use_playbooks'],
    },
  },
];

// The Office taskpane has no real URL bar — Office.js appends `_host_Info`
// to the taskpane URL, which we use to switch to in-memory history.
export function createAppHistory(baseUrl: string): RouterHistory {
  const isOfficeTaskpane =
    typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('_host_Info');
  return isOfficeTaskpane ? createMemoryHistory() : createWebHistory(baseUrl);
}

/**
 * Office-specific navigation redirects. Returns the redirect target path,
 * or null when no office redirect applies and the generic guard logic
 * should proceed.
 */
export function resolveOfficeRedirect(
  to: RouteLocationNormalized,
  isAuthenticated: boolean
): string | null {
  if (isOfficeAddinHost() && (to.name === 'login' || to.name === 'sign-up')) {
    return '/office-login';
  }
  if (!isOfficeAddinHost() && to.name === 'office-login') {
    return '/login';
  }
  if (!isOfficeAddinHost() && (to.name === 'office-templates' || to.name === 'office-playbooks')) {
    // These task-pane views only make sense inside Word.
    return '/';
  }
  if (isOfficeAddinHost() && isAuthenticated && to.name === 'home') {
    return '/vault';
  }
  return null;
}
